import globalLogger from '../../logger';
import {
    platformSupportsIndexedDb,
    platformSupportsServiceWorker,
    platformSupportsWebWorkers,
} from './platformFeatureDetectionUtils';

export const platformSupportLogger = globalLogger.createChannel('platform-support');

/**
 * Logs important feature support information.
 */
export const checkImportantFeaturePlatformSupport = () => {
    const supportsWebWorkers = platformSupportsWebWorkers();
    const supportsIndexedDb = platformSupportsIndexedDb();
    const supportsServiceWorker = platformSupportsServiceWorker();

    platformSupportLogger.info('Feature support:', {
        supportsWebWorkers,
        supportsIndexedDb,
        supportsServiceWorker,
    });
};
